import {
  CheckBadgeIcon,
  ShieldCheckIcon,
  SparklesIcon,
} from "@heroicons/react/16/solid";

const ServiceAdvantage = () => (
  <section
    id="advantages"
    className="w-full overflow-x-hidden lg:px-21 md:px-10 px-4 py-5"
  >
    <div className="max-w-7xl mx-auto text-center mb-4">
      <h2 className="md:text-4xl text-3xl font-semibold text-gray-900 mb-4">
        360 Service Advantage
      </h2>
      <p className="md:text-xl text-base font-normal text-gray-500">
        Why thousands trust us with their service orders
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3">
      <div className="flex flex-col items-center text-center md:p-10 p-2 lg:px-14 border-b border-gray-200/60 md:border-r">
        <div className="w-12 h-12 mt-2 rounded-full flex items-center justify-center text-blue-500 text-3xl">
          <SparklesIcon className="w-8 h-8" />
        </div>
        <h3 className="text-2xl font-medium text-gray-900 mb-3">
          Simple Process
        </h3>
        <p className="text-base font-normal text-gray-500 max-w-md">
          We streamline every step so you can submit, ship, and track your
          service without confusion, saving time and avoiding unnecessary costs.
        </p>
      </div>

      {/* <div className="flex flex-col items-center text-center md:p-10 p-2 lg:px-14 border-b border-gray-200/60 md:border-r">
        <div className="w-12 h-12 mt-2 rounded-full flex items-center justify-center text-blue-500 text-3xl">
          <ClockIcon className="w-8 h-8" />
        </div>
        <h3 className="text-2xl font-medium text-gray-900 mb-3">
          Real-Time Tracking
        </h3>
        <p className="text-base font-normal text-gray-500 max-w-md">
          Monitor your item's status, shipping updates, and service progress in
          one unified place, and ensure the service provider knows when to
          expect your package so it arrives and gets serviced on time without
          delays.
        </p>
      </div> */}

      <div className="flex flex-col items-center text-center md:p-10 p-2 lg:px-14 border-b border-gray-200/60 md:border-r">
        <div className="w-12 h-12 mt-2 rounded-full flex items-center justify-center text-blue-500 text-3xl">
          <CheckBadgeIcon className="w-8 h-8" />
        </div>
        <h3 className="text-2xl font-medium text-gray-900 mb-3">
          Verified Accuracy
        </h3>
        <p className="text-base font-normal text-gray-500 max-w-md">
          Your vehicle and part information is validated to prevent errors,
          reduce delays, and ensure your part is fully supported.
        </p>
      </div>

      <div className="flex flex-col items-center text-center md:p-10 p-2 lg:px-14 border-b border-gray-200/60 md:border-r">
        <div className="w-12 h-12 mt-2 rounded-full flex items-center justify-center text-blue-500 text-3xl">
          <ShieldCheckIcon className="w-8 h-8" />
        </div>
        <h3 className="text-2xl font-medium text-gray-900 mb-3">
          Trusted Service
        </h3>
        <p className="text-base font-normal text-gray-500 max-w-md">
          We prioritize reliability, transparency, and secure handling of your
          components throughout the entire process.
        </p>
      </div>
    </div>
  </section>
);

export default ServiceAdvantage;
